import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import { State, stateSubject } from '../../../helpers';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent implements OnInit {
  @Output() onChange = new EventEmitter<string>();
  @Output() onFocus = new EventEmitter<void>();

  @Input() value: string = '';

  state: State;

  searchIcon = faSearch;
  clearIcon = faClose;

  constructor() {}

  ngOnInit() {
    stateSubject.subscribe(({ state }) => (this.state = state));
  }

  onInput = ({ target }) => this.onChange.emit(target.value);
}
